export const PICKLIST = 'picklist';
export const MULTI_PICKLIST = 'multipicklist';
export const NUMBER = 'number';
export const CURRENCY = 'currency';
export const DOLLARS = 'usd';
export const MULTILINE = 'multiline';
export const PERCENT = 'percent';
export const STRING = 'string';
export const BOOL = 'bool';
export const DATE = 'date';
export const DATE_TIME = 'datetime';

export const YES = '1';
export const NO = '0';
